/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleHistoryManagementExportOrderResponse } from './CarpsaleHistoryManagementExportOrderResponse';

export type CarpsaleHistoryManagementExportOrderResponseApiRespoonse = {
    data?: CarpsaleHistoryManagementExportOrderResponse;
    status?: CarpsaleHistoryManagementExportOrderResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleHistoryManagementExportOrderResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

